/* ZINKE — Suche mit Sofortvorschlaegen und Woerterbuch (15.09.2026)
 *
 * Zwei Quellen, die zusammen gerendert werden:
 *
 * 1. WOERTERBUCH aus snippets/suche-panel.liquid. Eigene Liste
 *    Stichwort -> Ziel. Faengt Anliegen ab, die kein Produkt sind:
 *    "Sendungsverfolgung", "Rueckgabe", "Kontakt", "Geschenk fuer Papa".
 *    Vergleich ohne Umlaute und ohne Gross-/Kleinschreibung.
 *
 * 2. SOFORTVORSCHLAEGE von Shopify: /search/suggest.json liefert Produkte,
 *    Seiten und Blogbeitraege waehrend des Tippens. Grenzen laut Doku:
 *    resources[limit] 1-10, Praefix-Treffer nur beim letzten Wort, die
 *    ersten vier Buchstaben muessen stimmen, ein Tippfehler wird verziehen.
 *
 * Kein Fremdcode, keine App, kein Tarifwechsel noetig.
 */
(() => {
  'use strict';

  const wurzelEl = document.querySelector('[data-suche]');
  const datenEl = document.getElementById('zinke-suchdaten');
  if (!datenEl) return;

  let daten;
  try {
    daten = JSON.parse(datenEl.textContent);
  } catch (e) {
    return;
  }
  const themen = (daten.themen || []).filter(x => x.u && x.u.length > 1);
  const beliebt = daten.beliebt || [];
  const start = (daten.start || []).filter(x => x.u && x.u.length > 1);

  /* ---------- Textvergleich ------------------------------------------- */

  const normalisieren = wert => (wert || '')
    .toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9€ ]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  // Stichwoerter einmal vorbereiten, damit beim Tippen nichts gerechnet wird.
  themen.forEach(thema => {
    thema._k = (thema.k || []).map(normalisieren).filter(Boolean);
    thema._t = normalisieren(thema.t);
  });

  const themenTreffer = eingabe => {
    const q = normalisieren(eingabe);
    if (q.length < 2) return [];

    const punkte = [];
    themen.forEach((thema, platz) => {
      let best = 0;
      const pruefen = wort => {
        if (!wort) return;
        if (wort === q) best = Math.max(best, 100);
        else if (wort.startsWith(q)) best = Math.max(best, 80 - Math.min(20, wort.length - q.length));
        else if (q.startsWith(wort) && wort.length >= 4) best = Math.max(best, 70);
        else if (q.length >= 4 && wort.includes(q)) best = Math.max(best, 55);
        else if (wort.length >= 5 && q.includes(wort)) best = Math.max(best, 50);
      };
      pruefen(thema._t);
      thema._k.forEach(pruefen);
      if (best > 0) punkte.push({ thema, best: best - platz * 0.01 });
    });

    return punkte.sort((a, b) => b.best - a.best).map(x => x.thema);
  };

  /* ---------- Hilfen --------------------------------------------------- */

  const esc = wert => String(wert == null ? '' : wert)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const preisFormat = new Intl.NumberFormat('de-DE', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 2
  });

  const preis = wert => {
    const zahl = parseFloat(String(wert).replace(',', '.'));
    return isNaN(zahl) ? '' : preisFormat.format(zahl);
  };

  const bildGroesse = (adresse, breite) => {
    if (!adresse) return '';
    return adresse + (adresse.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite;
  };

  // Hebt den getippten Teil im Treffer hervor.
  const hervorheben = (text, eingabe) => {
    const roh = String(text || '');
    const q = normalisieren(eingabe);
    if (q.length < 2) return esc(roh);
    const stelle = normalisieren(roh).indexOf(q);
    if (stelle < 0) return esc(roh);
    // Die Normalisierung kann die Laenge verschieben (ü -> ue). Deshalb wird
    // nur markiert, wenn sich die Stelle im Originaltext wiederfindet.
    const wieOriginal = roh.toLowerCase().indexOf(eingabe.toLowerCase().trim());
    if (wieOriginal < 0) return esc(roh);
    const laenge = eingabe.trim().length;
    return esc(roh.slice(0, wieOriginal)) +
      '<mark>' + esc(roh.slice(wieOriginal, wieOriginal + laenge)) + '</mark>' +
      esc(roh.slice(wieOriginal + laenge));
  };

  const PFEIL = '<span class="zinke-suche-pfeil"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M12 5l7 7-7 7"/></svg></span>';
  // Diagonaler Pfeil: sagt "bringt dich woanders hin" und unterscheidet die
  // Themenzeilen ruhig von den Produktbildern.
  const MARKE = '<span class="zinke-suche-marke"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 16L16 8M9.5 8H16v6.5"/></svg></span>';

  const themenZeile = (thema, eingabe) =>
    '<a class="zinke-suche-zeile" role="option" href="' + esc(thema.u) + '">' +
      MARKE +
      '<span class="zinke-suche-text">' +
        '<span class="zinke-suche-name">' + hervorheben(thema.t, eingabe) + '</span>' +
        (thema.b ? '<span class="zinke-suche-zusatz">' + esc(thema.b) + '</span>' : '') +
      '</span>' + PFEIL +
    '</a>';

  const produktZeile = (artikel, eingabe) => {
    const bild = artikel.featured_image && artikel.featured_image.url;
    const wert = artikel.price != null ? artikel.price : (artikel.price_min != null ? artikel.price_min : '');
    const titel = String(artikel.title || '').split(' – ')[0];
    return '<a class="zinke-suche-zeile" role="option" href="' + esc(artikel.url) + '">' +
      (bild
        ? '<img class="zinke-suche-bild" src="' + esc(bildGroesse(bild, 120)) + '" alt="" loading="lazy" width="44" height="44">'
        : '<span class="zinke-suche-marke"></span>') +
      '<span class="zinke-suche-text">' +
        '<span class="zinke-suche-name">' + hervorheben(titel, eingabe) + '</span>' +
        (artikel.product_type ? '<span class="zinke-suche-zusatz">' + esc(artikel.product_type) + '</span>' : '') +
      '</span>' +
      (wert !== '' ? '<span class="zinke-suche-preis">' + esc(preis(wert)) + '</span>' : PFEIL) +
    '</a>';
  };

  const textZeile = (eintrag, art, eingabe) =>
    '<a class="zinke-suche-zeile" role="option" href="' + esc(eintrag.url) + '">' +
      MARKE +
      '<span class="zinke-suche-text">' +
        '<span class="zinke-suche-name">' + hervorheben(eintrag.title, eingabe) + '</span>' +
        '<span class="zinke-suche-zusatz">' + esc(art) + '</span>' +
      '</span>' + PFEIL +
    '</a>';

  const gruppe = (ueberschrift, inhalt) =>
    '<div class="zinke-suche-gruppe"><p class="zinke-suche-titel">' + esc(ueberschrift) + '</p>' + inhalt + '</div>';

  /* ---------- Abfrage an Shopify --------------------------------------- */

  const suchPfad = (() => {
    const form = document.querySelector('[data-suche] form');
    try {
      return new URL(form ? form.action : '/search', window.location.origin).pathname;
    } catch (e) {
      return '/search';
    }
  })();
  const basis = suchPfad.replace(/\/search\/?$/, '');
  const vorschlagAdresse = eingabe => basis + '/search/suggest.json' +
    '?q=' + encodeURIComponent(eingabe) +
    '&resources[type]=product,page,article' +
    '&resources[limit]=4' +
    '&resources[options][limit_scope]=each' +
    '&resources[options][unavailable_products]=last' +
    '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

  let laufend = null;
  const vorschlaegeHolen = eingabe => {
    if (laufend) laufend.abort();
    laufend = new AbortController();
    return fetch(vorschlagAdresse(eingabe), { signal: laufend.signal })
      .then(antwort => (antwort.ok ? antwort.json() : null))
      .then(json => (json && json.resources && json.resources.results) || null)
      .catch(() => null);
  };

  /* ---------- Panel ---------------------------------------------------- */

  if (!wurzelEl) return;

  const feld = wurzelEl.querySelector('[data-suche-feld]');
  const koerper = wurzelEl.querySelector('[data-suche-koerper]');
  const formular = wurzelEl.querySelector('form');
  let letzterAusloeser = null;
  let wartezeit = null;
  let laufendeEingabe = '';

  const startAnsicht = () => {
    let html = '';
    if (beliebt.length) {
      html += gruppe('Beliebte Suchen',
        '<div class="zinke-suche-chips">' +
          beliebt.map(wort => '<button class="zinke-suche-chip" type="button" data-chip="' + esc(wort) + '">' + esc(wort) + '</button>').join('') +
        '</div>');
    }
    if (start.length) {
      html += gruppe('Schnell zum Ziel',
        start.map(eintrag =>
          '<a class="zinke-suche-zeile" role="option" href="' + esc(eintrag.u) + '">' +
            MARKE +
            '<span class="zinke-suche-text"><span class="zinke-suche-name">' + esc(eintrag.t) + '</span></span>' +
            PFEIL +
          '</a>').join(''));
    }
    koerper.innerHTML = html;
    feld.setAttribute('aria-expanded', 'true');
  };

  const zeichnen = (eingabe, ergebnisse) => {
    const treffer = themenTreffer(eingabe).slice(0, 2);
    let html = '';

    if (treffer.length) {
      html += gruppe('Das meinst du wahrscheinlich',
        treffer.map(thema => themenZeile(thema, eingabe)).join(''));
    }

    const produkte = (ergebnisse && ergebnisse.products) || [];
    if (produkte.length) {
      html += gruppe('Produkte', produkte.slice(0, 4).map(a => produktZeile(a, eingabe)).join(''));
    }

    const seiten = (ergebnisse && ergebnisse.pages) || [];
    const artikel = (ergebnisse && ergebnisse.articles) || [];
    const rest = seiten.slice(0, 2).map(e => textZeile(e, 'Seite', eingabe))
      .concat(artikel.slice(0, 2).map(e => textZeile(e, 'Beitrag', eingabe)));
    if (rest.length) html += gruppe('Seiten und Beiträge', rest.join(''));

    if (!html) {
      html = '<div class="zinke-suche-leer">Nichts gefunden zu <strong>' + esc(eingabe) + '</strong>.<br>Versuch einen kürzeren Begriff.</div>';
      if (beliebt.length) {
        html += '<div class="zinke-suche-chips">' +
          beliebt.map(wort => '<button class="zinke-suche-chip" type="button" data-chip="' + esc(wort) + '">' + esc(wort) + '</button>').join('') +
          '</div>';
      }
    } else {
      html += '<div class="zinke-suche-fuss"><a class="zinke-suche-alle" href="' + esc(suchPfad) + '?q=' + encodeURIComponent(eingabe) + '&options%5Bprefix%5D=last">' +
        '<span>Alle Ergebnisse ansehen</span>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M12 5l7 7-7 7"/></svg>' +
        '</a></div>';
    }

    koerper.innerHTML = html;
    koerper.scrollTop = 0;
  };

  const aktualisieren = () => {
    const eingabe = feld.value.trim();
    laufendeEingabe = eingabe;

    if (eingabe.length < 2) {
      startAnsicht();
      return;
    }

    // Das Woerterbuch antwortet sofort, die Produkte kommen nach.
    zeichnen(eingabe, null);
    vorschlaegeHolen(eingabe).then(ergebnisse => {
      if (laufendeEingabe !== eingabe) return;
      zeichnen(eingabe, ergebnisse);
    });
  };

  const oeffnen = (ausloeser, vorgabe) => {
    letzterAusloeser = ausloeser || null;
    // Ein offenes Menuepanel wuerde sonst hinter dem Suchblatt stehen bleiben.
    document.querySelectorAll('details[open]').forEach(auf => { auf.open = false; });
    wurzelEl.hidden = false;
    document.documentElement.classList.add('suche-offen');
    if (typeof vorgabe === 'string' && vorgabe) feld.value = vorgabe;
    if (feld.value.trim().length >= 2) aktualisieren();
    else startAnsicht();
    window.setTimeout(() => {
      feld.focus();
      feld.select();
    }, 40);
  };

  const schliessen = () => {
    wurzelEl.hidden = true;
    document.documentElement.classList.remove('suche-offen');
    feld.setAttribute('aria-expanded', 'false');
    if (letzterAusloeser && document.contains(letzterAusloeser)) letzterAusloeser.focus();
  };

  // Jeder Suchlink im Kopfbereich oeffnet das Panel. Ohne JavaScript
  // bleiben es normale Links auf die Suchseite.
  // 4.4: Ziel kann in alten Browsern ein Textknoten oder das Dokument sein
  // (Clarity 19.09.: „ereignis.target.closest is not a function“).
  const element = ziel => (ziel && ziel.nodeType === 3 ? ziel.parentElement : ziel);
  document.addEventListener('click', roh => {
    const t = element(roh.target);
    if (!t || typeof t.closest !== 'function') return;
    const ereignis = { target: t, preventDefault: () => roh.preventDefault() };
    const ausloeser = ereignis.target.closest('a[href*="/search"], [data-suche-auf]');
    if (ausloeser && !ausloeser.closest('[data-suche]') && !ausloeser.hasAttribute('data-suche-egal')) {
      ereignis.preventDefault();
      oeffnen(ausloeser);
      return;
    }
    if (ereignis.target.closest('[data-suche-zu]')) {
      ereignis.preventDefault();
      schliessen();
      return;
    }
    const chip = ereignis.target.closest('[data-chip]');
    if (chip) {
      ereignis.preventDefault();
      feld.value = chip.getAttribute('data-chip');
      feld.focus();
      aktualisieren();
    }
  });

  // Das Suchfeld auf der Ergebnisseite oeffnet beim Antippen dasselbe Panel,
  // damit es dort nicht zwei verschiedene Suchen gibt.
  document.addEventListener('focusin', ereignis => {
    if (!ereignis.target || typeof ereignis.target.closest !== 'function') return;
    const ziel = ereignis.target.closest('[data-suche-auf-fokus]');
    if (!ziel || wurzelEl.hidden === false) return;
    ziel.blur();
    oeffnen(ziel, ziel.value || '');
  });

  feld.addEventListener('input', () => {
    window.clearTimeout(wartezeit);
    wartezeit = window.setTimeout(aktualisieren, 170);
  });

  formular.addEventListener('submit', ereignis => {
    const aktiv = koerper.querySelector('.zinke-suche-zeile.ist-aktiv');
    if (aktiv) {
      ereignis.preventDefault();
      window.location.href = aktiv.getAttribute('href');
    }
  });

  // Pfeiltasten wandern durch die Vorschlaege, Escape schliesst.
  wurzelEl.addEventListener('keydown', ereignis => {
    if (ereignis.key === 'Escape') {
      ereignis.preventDefault();
      schliessen();
      return;
    }
    if (ereignis.key !== 'ArrowDown' && ereignis.key !== 'ArrowUp') return;

    const zeilen = Array.prototype.slice.call(koerper.querySelectorAll('.zinke-suche-zeile'));
    if (!zeilen.length) return;
    ereignis.preventDefault();

    const jetzt = zeilen.findIndex(zeile => zeile.classList.contains('ist-aktiv'));
    let naechste = ereignis.key === 'ArrowDown' ? jetzt + 1 : jetzt - 1;
    if (naechste < -1) naechste = zeilen.length - 1;
    if (naechste >= zeilen.length) naechste = -1;

    zeilen.forEach(zeile => zeile.classList.remove('ist-aktiv'));
    if (naechste >= 0) {
      zeilen[naechste].classList.add('ist-aktiv');
      zeilen[naechste].scrollIntoView({ block: 'nearest' });
    }
  });

  /* ---------- Ergebnisseite -------------------------------------------- */

  const hinweisPlatz = document.querySelector('[data-suche-hinweis]');
  if (hinweisPlatz) {
    const begriff = hinweisPlatz.getAttribute('data-begriff') || '';
    const treffer = themenTreffer(begriff)[0];
    if (treffer) {
      hinweisPlatz.innerHTML =
        '<a class="suche-hinweis" href="' + esc(treffer.u) + '">' +
          '<span class="suche-hinweis-text">' +
            '<span class="suche-hinweis-klein">Meinst du</span>' +
            '<span class="suche-hinweis-gross">' + esc(treffer.t) + (treffer.b ? ' — ' + esc(treffer.b) : '') + '</span>' +
          '</span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M12 5l7 7-7 7"/></svg>' +
        '</a>';
    }
  }

  const leerPlatz = document.querySelector('[data-suche-beliebt]');
  if (leerPlatz && beliebt.length) {
    leerPlatz.innerHTML = '<div class="zinke-suche-chips" style="justify-content:center;padding-left:0;padding-right:0">' +
      beliebt.map(wort =>
        '<a class="zinke-suche-chip" data-suche-egal href="' + esc(suchPfad) + '?q=' + encodeURIComponent(wort) + '&options%5Bprefix%5D=last">' + esc(wort) + '</a>'
      ).join('') + '</div>';
  }
})();
